import { render, staticRenderFns } from "./Sala.vue?vue&type=template&id=07aaa6a7&"
import script from "./Sala.vue?vue&type=script&lang=js&"
export * from "./Sala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports